import {Link} from 'react-router-dom'
import Logo from '../images/MadMonkStudio.svg'
import { FaLinkedin } from 'react-icons/fa'
import { FaFacebookF } from 'react-icons/fa'
import { AiOutlineTwitter } from 'react-icons/ai'
import { AiFillInstagram } from 'react-icons/ai'




const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }
    
  return (
    <footer>
        <div className="container footer__container">
            <article>
                <Link to="/" className='logo'>
                    <img src={Logo} alt="Footer Logo" />
                </Link>
                <p>
                MadMonk Is A Design Company. That Creates Innovative Spatial Experiences By Integrating Content And Digital Media Technology.
                </p>
                <div className="footer__socials">
                    <a href="https://linkedin.com/" target="_blank" rel='noreferrer noopener'><FaLinkedin/></a>
                    <a href="https://facebook.com/" target="_blank" rel='noreferrer noopener'><FaFacebookF/></a>
                    <a href="https://twitter.com/" target="_blank" rel='noreferrer noopener'><AiOutlineTwitter/></a>
                    <a href="https://instagram.com/" target="_blank" rel='noreferrer noopener'><AiFillInstagram/></a>
                </div>
            </article>
            <article>
                <h4>Permalinks</h4>
                <Link to="/" onClick={() => scrollToTop()}>Home</Link>
                <Link to="/about" onClick={() => scrollToTop()}>About</Link>
                <Link to="/contact" onClick={() => scrollToTop()}>Contact</Link>
            </article>
            <article>
                <h4>Projects</h4>
                <Link to="/projectscgi" onClick={() => scrollToTop()}>CGI</Link>
                <Link to="/projectsconfigurators" onClick={() => scrollToTop()}>Configurators</Link>
                <Link to="/projectsinteractive" onClick={() => scrollToTop()}>Interactive Media</Link>
                <Link to="/projectsvrar" onClick={() => scrollToTop()}>VR / AR</Link>
            </article>
            <article>
                <h4>Services</h4>
                <Link to="/servicescgi" onClick={() => scrollToTop()}>CGI</Link>
                <Link to="/servicesconfigurators" onClick={() => scrollToTop()}>Configurators</Link>
                <Link to="/servicesinteractives" onClick={() => scrollToTop()}>Interactive Media</Link>
                <Link to="/servicesvr" onClick={() => scrollToTop()}>VR</Link>
                <Link to="/servicesar" onClick={() => scrollToTop()}>AR</Link>
            </article>
        </div>
        <div className="footer__copyright">
            <small>2024 MadMonk &copy; All Rights Reserved</small>
        </div>
    </footer>
  )
}

export default Footer